<ng-template [ngIf]="useSiteLogoTemplate">
  <cx-banner [style.display]="hasRequested === 'true' ? 'none' : 'block'">
    <ng-container *ngIf="!disabledLinkLogo; else disabledLink">
      <cx-generic-link>
        <a role="link" title="Shimano" [routerLink]="urlLink">
          <cx-media>
            <img src="../../../../../../public/icons/png/logo-shimano.png" alt="Shimano" />
          </cx-media>
        </a>
      </cx-generic-link>
    </ng-container>
    <ng-template #disabledLink>
      <cx-media>
        <img src="../../../../../../public/icons/png/logo-shimano.png" alt="Shimano" />
      </cx-media>
    </ng-template>
  </cx-banner>
</ng-template>
